import { useQuery } from '@tanstack/react-query';
import {
  fetchHomepageBrowseTagProgress,
  type HomepageBrowseTagProgressRow,
} from '@/lib/services/homepageBrowseTags';
import { useAuthId } from '@/hooks/useAuthId';

/** Invalidate with this key (partial match) after quiz/endless answers so browse progress refetches. */
export const homepageBrowseTagProgressQueryRootKey = ['homepageBrowseTagProgress'] as const;

export function useHomepageBrowseTagProgressQuery(tagIds: number[]) {
  const { userId, isResolved, isAuthenticated } = useAuthId();
  const isAnonymous = !isAuthenticated;

  return useQuery<HomepageBrowseTagProgressRow[]>({
    queryKey: [...homepageBrowseTagProgressQueryRootKey, userId, isAnonymous, tagIds] as const,
    queryFn: () => fetchHomepageBrowseTagProgress({ userId: userId!, isAnonymous }, tagIds),
    enabled: isResolved && !!userId && tagIds.length > 0,
    staleTime: 0,
    gcTime: typeof window === 'undefined' ? Infinity : 5 * 60 * 1000,
  });
}
